<mat-card class="example-card">
    <mat-card-header class="titreFrm">
        <mat-card-title>Matière</mat-card-title>
    </mat-card-header>
    <mat-card-content class="border">
        <div *ngIf="exist;else attente"></div>
        <ng-template #attente>
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </ng-template>
        <form class="example-form" #form="ngForm">
        <mat-card class="example-card carClass">
            <mat-card-content>
                <div class="display-flex">
                    <mat-form-field     appearance="outline"  style="width: 200px;" class="heightInput">
                        <mat-label>Matière</mat-label>
                        <mat-select name="Matiere_Code" #Matiere_Code="ngModel" [(ngModel)]="matiere.Matiere_Code"
                            placeholder="Matière"  required>
                            <mat-option *ngFor="let mat of listeAllMatiere" [value]="mat.DiverSys_Index">
                            {{mat.DiverSys_Titre}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <div>
                        <mat-icon (click)="openFrmAvtMatiere()" class="colorGreen icon">add</mat-icon>
                    </div>
                    <mat-form-field     appearance="outline"  style="width: 200px;" class="heightInput">
                        <mat-label>Salle</mat-label>
                        <mat-select name="CursusD_TypeSalle" #CursusD_TypeSalle="ngModel" [(ngModel)]="matiere.CursusD_TypeSalle"
                            placeholder="Salle"  required>
                            <mat-option *ngFor="let sale of listeAllSalle" [value]="sale.DiverSys_Index">
                            {{sale.DiverSys_Titre}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field     appearance="outline"  >
                        <mat-label>Durée</mat-label>
                        <input matInput type="number" name="CursusD_Duree" #CursusD_Duree="" [(ngModel)]="matiere.CursusD_Duree"
                        placeholder="Durée" required>
                    </mat-form-field>
                    
                </div>

            </mat-card-content>
            <mat-card-actions>
                <div style="display: flex;justify-content: space-between;" >
                    <button (click)="ajouter(form)" [disabled]="disableBtnAjouter" mat-raised-button class="colorGreen"><mat-icon>save</mat-icon>Enregistrer</button>
                    <button (click)="close()" mat-raised-button class="colorRed"><mat-icon>close</mat-icon>Fermer</button>
                </div>
            </mat-card-actions>
        </mat-card></form>
    </mat-card-content>
</mat-card>
            